import axios from 'axios';

const instance = axios.create({
    baseURL: String(process.env.VUE_APP_AXIOS_BASE_URL)
});

export default instance;
